//@flow strict

// Return true only if the app shell is saved on localStorage as collapsed(false). Else, returns false.
export const getAppShellStatus = (): boolean => {
  try {
    const key = getAppShellStatusKey();
    const value = localStorage.getItem(key);
    return value === 'false';
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const setAppShellStatus = (value: string): void => {
  try {
    const key = getAppShellStatusKey();
    localStorage.setItem(key, value);
  } catch (e) {
    console.log(e);
  }
};

export function getAppShellStatusKey(): string {
  return `isSideNavExpanded`;
}
